/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

/**
 * Maps intl locale codes to OneConsole language format
 * @param locale - The intl locale code (e.g., 'en', 'fr', 'ja')
 * @returns The formatted locale string for OneConsole (e.g., 'en', 'fr-FR', 'ja-JP')
 */
export const mapLocaleToConsoleLanguage = (locale: string): string => {
  switch (locale) {
    case 'fr':
      return 'fr-FR'
    case 'ja':
      return 'ja-JP'
    case 'zh':
      return 'zh-CN'
    case 'de':
      return 'de-DE'
    case 'en':
    default:
      return 'en'
  }
}
